import {Component, Input} from '@angular/core';
import {Website} from "../../../websites/website/website";
import {GoogleAnalyticsService} from "../../services/google-analytics/google-analytics.service";
import {UserSubscription} from "../../../user/user-subscription";


@Component({
    selector: 'db-booster-activation-banner',
    templateUrl: './booster-activation-banner.component.html',
    styleUrls: ['./booster-activation-banner.component.scss'],
    standalone: false
})
export class BoosterActivationBannerComponent {
  @Input() companyName: string;
  @Input() website: Website;
  @Input() fromPages: boolean;
  @Input() currentSubscription: UserSubscription;

  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService
  ) {}

  public getWpImageOptimizerPage(): void {
    window.open(this.website.adminActivateBoosterUrl, "_blank", "noopener");
  }
}
